import CustomStore from 'devextreme/data/custom_store';
import { ref } from 'vue';
import useTextRepository from '@/modules/masterData/cmsPIIText/repositories/text.repository.js';
import store from '@/store/index';

export default function useDatagrid() {
  const textRepostory = useTextRepository();
  const datasource = ref();

  const getDatasource = () => {
    datasource.value = new CustomStore({
      key: 'id',
      load: (loadOptions) => textRepostory.load(loadOptions)
        .then((response) => ({
          data: response.data.data,
          totalCount: response.data.totalCount,
          summary: response.data.summary,
          groupCount: response.data.groupCount,
        })),
      update: (key, values) => new Promise((resolve, reject) => {
        textRepostory.update(key, values)
          .then((response) => {
            if (response.data.success) {
              store.dispatch('addSuccessNotification', 'Dine ændringer er gemt');
              resolve(response);
            } else {
              if (response.data.messages.length > 0) {
                store.dispatch('addNotifications', { messageList: response.data.messages });
              }
              reject();
            }
          });
      }),
    });
  };

  return {
    datasource,
    getDatasource,
  };
}
